import React, { useContext } from "react";
import { Link } from "react-router-dom";
import styles from "./MenuItem.module.scss";
import MenuContext from "../../../../contexts/menu/MenuContext";
import classNames from "classnames";
import { useAsync } from "react-use";

interface Props {
    // ID for the menu-item
    id: string;
    // The route to go to if the item is clicked
    route: string;
    // The name to show in the menu
    children: string;
    // Whether shopping-cart should be shown on the page
    withCart?: boolean;
    // Function to execute on click
    onClick: () => void;
}

const MenuItem: React.FC<Props> = props => {
    const { activeMenuItem, setActiveMenuItem, addMenuItem } = useContext(MenuContext);

    useAsync(async () => {
        addMenuItem({
            id: props.id,
            route: props.route,
            name: props.children,
            withCart: props.withCart,
        });
    });

    const onClick = () => {
        setActiveMenuItem(props.id);
        props.onClick();
    };

    return (
        <li className={classNames(styles.item, { [styles.active]: activeMenuItem === props.id })} onClick={onClick}>
            <Link to={props.route}>
                <span>{props.children}</span>
            </Link>
        </li>
    );
};

export default MenuItem;
